/**
 * FDA Daily Values for Phase 3 Micronutrients
 * Based on FDA Daily Value Reference Amounts (2020)
 *
 * These values are used for displaying progress percentages
 * when the user hasn't set custom targets.
 */

export const FDA_DAILY_VALUES = {
  // Fat breakdown
  saturatedFat: 20, // grams
  cholesterol: 300, // mg

  // B Vitamins
  vitaminB6: 1.7, // mg
  vitaminB12: 2.4, // mcg
  folate: 400, // mcg DFE

  // Minerals
  magnesium: 420, // mg
  zinc: 11, // mg
  phosphorus: 1250 // mg
}

/**
 * Get FDA daily value for a nutrient
 * @param {string} nutrient - The nutrient key (camelCase)
 * @returns {number|null} The FDA daily value or null if not found
 */
export function getFdaDailyValue(nutrient) {
  return FDA_DAILY_VALUES[nutrient] ?? null
}

/**
 * Calculate progress percentage against FDA daily value
 * @param {number} value - Current intake value
 * @param {string} nutrient - The nutrient key
 * @returns {number} Progress percentage (0-100+)
 */
export function calculateFdaProgress(value, nutrient) {
  const target = getFdaDailyValue(nutrient)
  if (!target || target === 0) return 0
  return (value / target) * 100
}

/**
 * Get all FDA daily values as targets object
 * (compatible with MicronutrientsPanel targets prop)
 */
export function getFdaTargets() {
  return { ...FDA_DAILY_VALUES }
}

export default FDA_DAILY_VALUES
